export function setProductKey(productKey) {
  this.productKey = productKey;
}
